<!-- components/ConfirmDialog.vue -->
<script setup lang="ts">
interface Props {
  isVisible: boolean
  options: {
    title: string
    message: string
    confirmText: string
    cancelText: string
  }
}

interface Emits {
  (e: 'confirm'): void
  (e: 'cancel'): void
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const handleConfirm = () => {
  emit('confirm')
}

const handleCancel = () => {
  emit('cancel')
}

const handleOverlayClick = () => {
  emit('cancel')
}
</script>

<template>
  <div v-if="isVisible" class="confirm-overlay" @click="handleOverlayClick">
    <div class="confirm-dialog" @click.stop>
      <div class="confirm-header">
        <h3>{{ options.title }}</h3>
      </div>

      <div class="confirm-body">
        <p>{{ options.message }}</p>
      </div>

      <div class="confirm-footer">
        <button class="btn btn-cancel" @click="handleCancel">
          {{ options.cancelText }}
        </button>
        <button class="btn btn-confirm" @click="handleConfirm">
          {{ options.confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.confirm-dialog {
  background: white;
  border-radius: 8px;
  min-width: 400px;
  max-width: 500px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.confirm-header {
  padding: 20px 20px 0;
  border-bottom: 1px solid #eee;
}

.confirm-header h3 {
  margin: 0 0 15px 0;
  font-size: 18px;
  font-weight: 600;
}

.confirm-body {
  padding: 20px;
}

.confirm-body p {
  margin: 0;
  line-height: 1.5;
  color: #666;
}

.confirm-footer {
  padding: 0 20px 20px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.btn-cancel {
  background: #f5f5f5;
  color: #666;
}

.btn-cancel:hover {
  background: #e8e8e8;
}

.btn-confirm {
  background: #ff4050;
  color: white;
}

.btn-confirm:hover {
  background: #ff4050;
}
</style>
